export default __webpack_public_path__ + "static/media/ic-search-gray.31ac83fb.svg";